import { render, staticRenderFns } from "./campus.vue?vue&type=template&id=01aafe91&"
import script from "./campus.vue?vue&type=script&lang=js&"
export * from "./campus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports